<template>
<div style="width: 100%; height: 100%; background-color:#ffffff;">
  <vxe-grid
    v-bind="gridOptions"
    :loading="isLoading"
    :columns="tableColumns"
    :data="dataList">
    <template #top>
      <div class="top-content">
        <div style="display: flex; align-items: center;">
          <span class="fs-18 fw-bold title-content">派单管理-当前派单</span>
          <div class="total-count-content">派单数量{{ totalCount }}</div>
          <i v-if="!isLoading" class="el-icon-refresh pointer refresh-icon" @click="refreshData"></i>
          <i v-if="isLoading" class="el-icon-loading pointer refresh-icon"></i>
        </div>
        <el-button type="primary" size="small" style="width: 80px;" @click="orderDispatch">派单</el-button>
      </div>
    </template>
    <template #dispatch-status="{ row }">
      <div v-if="row.dispatchType === 1" style="color: #e74c3c">长途订单</div>
      <div v-if="row.dispatchType === 0">普通订单</div>
    </template>
    <template #handle-operation="{row}">
      <div style="display: flex; align-items: center; justify-content: center;">
        <span class="pointer" style="color: #409EFF;" @click="handleShowDetail(row)">详情</span>
        <el-divider direction="vertical" />
        <span class="pointer" style="color: #409EFF;" @click="handleEdit(row)">编辑</span>
        <el-divider direction="vertical" />
        <el-popconfirm
          confirm-button-text='确定'
          cancel-button-text='取消'
          icon="el-icon-info"
          icon-color="red"
          title="是否确认删除该条派单信息？"
          @confirm="handleDelete(row)"
        >
          <div slot="reference">
            <span class="pointer" style="color: #ff8080;">删除</span>
          </div>
        </el-popconfirm>
      </div>
    </template>
    <template #cipher-slot="{ row }">
      <div>{{ row.cipher || '/' }}</div>
    </template>
    <template #pager>
      <vxe-pager
        :total="totalCount"
        :page-size="pageSize"
        :current-page.sync="page"
        :page-sizes="[20, 30, 50]"
        :layouts="['Sizes', 'PrevJump', 'PrevPage', 'JumpNumber', 'NextPage', 'NextJump', 'FullJump']"
        @page-change="handlePageChange">
      </vxe-pager>
    </template>
  </vxe-grid>
  <!-- 详情 -->
  <CommonDrawer
    :loading="drawerLoading"
    :propParams="detailParams"
    :showDrawer="showDetailDrawer"
    @close="closeDetailDrawer"
  >
    <template slot="drawer-content">
      <vxe-grid
        v-bind="imageGridOption"
        :columns="imageColumns"
        :data="imageList"
      >
        <template #img-status="{ row }">
          <span v-if="row.status === 0" style="color: #999999;">未派发</span>
          <span v-else style="color: #009322;">已派发</span>
        </template>
      </vxe-grid>
    </template>
    <div slot="drawer-footer">
      <el-button @click="closeDetailDrawer">关闭</el-button>
    </div>
  </CommonDrawer>
  <!-- 添加 -->
  <CommonDrawer
    :loading="drawerLoading"
    :propParams="drawerData"
    :showDrawer="showDrawer"
    :destroyOnClose="true"
    :wrapperClosable="false"
    @close="closeDispatchDrawer"
  >
    <template slot="drawer-content">
      <div style="width: 100%; height: 100%;">
        <el-form :model="dispatchInfo" ref="dispatchInfo" labelWidth="120px" :rules="rules" style="position: relative; width: 100%; height: 100%">
          <div style="width: 100%; height: 100%; padding: 12px; box-sizing: border-box;">
            <el-form-item label="是长途单" prop="isLongDistance">
              <el-switch v-model="dispatchInfo.isLongDistance"/>
            </el-form-item>
            <el-form-item prop="loadingAddress">
              <template slot="label"><i class="el-icon-truck form-icon" />装货</template>
              <el-input v-model="dispatchInfo.loadingAddress" placeholder="请输入装货地址" />
            </el-form-item>
            <el-form-item label="卸货" prop="destination">
              <template slot="label"><i class="el-icon-position form-icon" />卸货</template>
              <el-input v-model="dispatchInfo.destination" placeholder="请输入卸货地址" />
            </el-form-item>
            <el-form-item label="煤种" prop="coalVar">
              <el-input v-model="dispatchInfo.coalVar" placeholder="请输入煤种" />
            </el-form-item>
            <el-form-item label="运费" prop="cost">
              <el-input v-model="dispatchInfo.cost" placeholder="请输入运费" />
            </el-form-item>
            <el-form-item label="数量" prop="requirement">
              <el-input v-model="dispatchInfo.requirement" type="number" min="1" />
            </el-form-item>
            <el-form-item prop="orderPrice">
              <template slot="label" style="display: flex; align-items: center;">
                <span style="margin-right: 4px;">下单费用</span>
                <el-tooltip class="item" effect="dark" placement="bottom">
                  <i class="el-icon-info" />
                  <div slot="content">
                    <span>用户下单时支付的费用</span>
                  </div>
                </el-tooltip>
              </template>
              <el-input v-model="dispatchInfo.orderPrice" type="number" min="0" />
            </el-form-item>
            <el-form-item prop="needCipher">
              <template slot="label" style="display: flex; align-items: center;">
                <span style="margin-right: 4px;">派单加密</span>
                <el-tooltip class="item" effect="dark" placement="bottom">
                  <i class="el-icon-info" />
                  <div slot="content">
                    <span>启用派单加密</span>
                  </div>
                </el-tooltip>
              </template>
              <el-switch v-model="dispatchInfo.needCipher" />
            </el-form-item>
            <el-form-item v-if="dispatchInfo.needCipher" prop="cipher">
              <template slot="label" style="display: flex; align-items: center;">
                <span style="margin-right: 4px;">验证信息</span>
                <el-tooltip class="item" effect="dark" placement="bottom">
                  <i class="el-icon-info" />
                  <div slot="content">
                    <span>普通派单请勿填写此项</span>
                  </div>
                </el-tooltip>
              </template>
              <el-input v-model="dispatchInfo.cipher" />
            </el-form-item>
            <el-form-item label="自动派二维码">
              <el-switch v-model="dispatchInfo.QRCodeOrder" />
            </el-form-item>
            <el-form-item v-if="dispatchInfo.QRCodeOrder" label="上传二维码">
              <el-upload
                class="upload-QR-code-content"
                action="#"
                drag
                multiple
                :fileList="QRCodeList"
                :httpRequest="handleUpload"
                :onRemove="handleRemove"
              >
                <div slot="default">
                  <i class="el-icon-plus" style="font-size: 32px; color: #999999"></i>
                </div>
                <div slot="tip" class="el-upload__tip">{{ `已上传${QRCodeList.length}个，需要上传数量等于派单数量` }}</div>
              </el-upload>
            </el-form-item>
          </div>
        </el-form>
      </div>
    </template>
    <div slot="drawer-footer">
      <el-button type="primary" @click="handleDispatch('dispatchInfo')">立即派单</el-button>
      <el-button @click="closeDispatchDrawer">关闭</el-button>
    </div>
  </CommonDrawer>
  <!-- 编辑 -->
  <CommonDrawer
    :loading="drawerLoading"
    :propParams="editParams"
    :showDrawer="showEditDrawer"
    :destroyOnClose="true"
    @close="showEditDrawer = false"
  >
    <template slot="drawer-content">
      <el-form :model="dispatchDetail" labelWidth="100px" style="padding: 12px;">
        <el-form-item label="订单编号">
          <el-input v-model="dispatchDetail.coalId" disabled />
        </el-form-item>
        <el-form-item label="目的地">
          <el-input v-model="dispatchDetail.destination" />
        </el-form-item>
        <el-form-item label="煤种" prop="coalVar">
          <el-input v-model="dispatchDetail.coalVar" />
        </el-form-item>
        <el-form-item label="运费" prop="cost">
          <el-input v-model="dispatchDetail.cost" disabled />
        </el-form-item>
        <el-form-item label="派单数量" prop="requirement">
          <el-input v-model="dispatchDetail.requirement" />
        </el-form-item>
        <el-form-item label="密文">
          <el-input v-model="dispatchDetail.cipher" cipher />
        </el-form-item>
        <el-form-item label="二维码图片">
          <el-input v-model="dispatchDetail.coalQRCode" />
        </el-form-item>
      </el-form>
    </template>
    <div slot="drawer-footer">
      <el-button type="primary" @click="handleSubmit">保存</el-button>
      <el-button @click="closeEditDrawer">关闭</el-button>
    </div>
  </CommonDrawer>
</div>
</template>

<script>
import {mapActions} from "vuex";
import CommonDrawer from "@/components/common/commonDrawer.vue";
import { uploadFile, getFileNameUUID } from "@/utils/commonUpload"

export default {
  name: "currentDispatch",
  components: {
    CommonDrawer
  },
  data() {
    return {
      isLoading: false,
      totalCount: 0,
      dataList: [],
      gridOptions: {
        height: 'auto',
        border: 'full',
        showOverflow: 'tooltip',
        columnConfig: {
          resizable: true,
        },
        rowConfig: {
          isHover: true,
          height: 38,
        },
      },
      imageGridOption: {
        rowConfig: {
          isHover: true,
          height: 38,
        },
      },
      tableColumns: [{
        type: "seq",
        width: 60,
        title: " ",
        fixed: "left",
        align: "center",
        resizable: false,
      }, {
        field: "coalId",
        title: "派单编号",
        width: 200,
        minWidth: 100,
        fixed: "left",
        resizable: false,
      },  {
        title: '订单类型',
        width: 100,
        slots: {
          default: 'dispatch-status'
        }
      }, {
        field: "loadingAddress",
        title: "装货",
        width: 120,
        fixed: "left",
        formatter: ({ row }) => row.loadingAddress || '/'
      }, {
        field: "destination",
        title: "卸货",
        width: 120,
        fixed: "left",
      }, {
        field: "coalVar",
        title: "煤种",
        width: 140,
        minWidth: 140,
      }, {
        field: "cost",
        title: "运费",
        width: 60,
        minWidth: 60,
      }, {
        field: 'orderPrice',
        title: '抢单费用',
        width: 80,
        minWidth: 80,
      }, {
        field: "requirement",
        title: "派单数量",
        width: 120,
        minWidth: 120,
      }, {
        field: "dispatched",
        title: "已抢单数量",
        width: 120,
        minWidth: 120,
      }, {
        title: "二维码派单",
        width: 100,
        minWidth: 100,
        formatter: ({ row }) => row.QRCodeOrder ? '是' : '否'
      }, {
        field: "cipher",
        title: "密文",
        width: 100,
        minWidth: 100,
        slots: {
          default: 'cipher-slot'
        }
      // }, {
      //   field: "position",
      //   title: "打卡定位",
      //   width: 180,
      }, {
        field: "remarks",
        title: "备注",
        minWidth: 60,
      }, {
        title: '操作',
        width: 160,
        align: 'center',
        fixed: 'right',
        slots: {
          default: 'handle-operation'
        },
      }],
      imageColumns: [{
        type: "seq",
        width: 60,
        title: "#",
        fixed: "left",
        align: "center",
        resizable: false,
      }, {
        field: "url",
        title: "路径",
      }, {
        field: "status",
        title: "状态",
        slots: {
          default: 'img-status'
        }
      }],
      imageList: [],
      drawerLoading: false,
      drawerData: {
        title: '派单',
        size: '50%',
        showFooter: true
      },
      showDrawer: false,
      dispatchInfo: {},
      rules: {
        destination: [
          { required: true, message: '请输入目的地', trigger: 'blur' }
        ],
        coalVar: [
          { required: true, message: '请输入煤种', trigger: 'blur' }
        ],
        cost: [
          { required: true, message: '请输入运费', trigger: 'blur' }
        ],
        cipher: [
          { required: true, message: '请输入验证信息', trigger: 'blur' }
        ],
        requirement: [
          { required: true, message: '请输入数量', trigger: 'blur' }
        ],
        orderPrice: [
          { required: true, message: '请输入下单费用', trigger: 'blur' }
        ]
      },
      pageSize: 20,
      page: 1,
      showEditDrawer: false,
      showDetailDrawer: false,
      detailParams: {},
      editParams: {},
      dispatchDetail: {},
      QRCodeList: []
    }
  },
  created() {
    this.initData()
  },
  methods: {
    ...mapActions({
      dispatchedOrder: 'dispatchedOrder',
      addDispatch: 'addDispatch',
      editDispatch: 'editDispatch',
      getDispatchDetail: 'getDispatchDetail'
    }),
    initData () {
      this.isLoading = true
      const params = {
        dispatchStatus: 0,
        pageSize: this.pageSize,
        page: this.page
      }
      this.dispatchedOrder(params).then(res => {
        this.isLoading = false
        if (res.paCode !== '000') {
          this.$message.error('获取派单信息失败' + res.paMsg);
          return
        }
        this.totalCount = res.paData.totalCount;
        this.dataList = res.paData.requests;
      })
    },
    refreshData () {
      this.initData()
    },
    orderDispatch () {
      this.QRCodeList = []
      this.showDrawer = true
    },
    getFileName(name){
      return  name.substring(name.lastIndexOf("."));  //.txt .png .jpg
    },
    handleUpload (option) {
      let fileName = getFileNameUUID() + this.getFileName(option.file.name)
      uploadFile(fileName, option.file).then(res => {
        this.QRCodeList.push({
          name: res.name,
          url: res.url
        });
      }).catch((err) => {
        this.$message({
          message: `上传失败-${fileName}-${err}`,
          type: 'error'
        })
      })
    },
    handleRemove(file, fileList) {
      this.QRCodeList = fileList
    },
    handleDispatch (formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          const params = this.cloneDeep(this.dispatchInfo)
          // 添加二维码派单（马泰壕）
          params.QRCodeOrder = params.QRCodeOrder ? 1 : 0
          if (params.QRCodeOrder) {
            if (this.QRCodeList.length === 0) {
              this.$message({
                message: '请上传二维码',
                type: 'warning'
              })
              return false;
            } else if (this.QRCodeList.length !== Number(params.requirement)) {
              this.$message({
                message: '二维码数量和派单数量不一致',
                type: 'warning'
              })
              return false;
            } else {
              params.imageUrlList = this.QRCodeList.map(item => item.url)
            }
          }
          params.needCipher = params.needCipher ? 1 : 0
          this.drawerLoading = true
          this.addDispatch(params).then(res => {
            this.drawerLoading = false
            if (res.paCode !== '000') {
              this.$message.error(res.paMsg || '操作失败');
            } else {
              this.$message.success(res.paMsg || '派单成功');
              this.closeDispatchDrawer()
              this.refreshData()
            }
          })
        } else {
          this.$message({
            message: '内容填写有误，请按照页面提示进行填写和修改',
            type: 'warning'
          })
          return false;
        }
      })
    },
    closeDispatchDrawer () {
      // 清空表单内容
      this.dispatchInfo = {}
      this.showDrawer = false
    },
    handlePageChange({currentPage, pageSize}) {
      this.pageSize = pageSize
      this.page = currentPage
      this.initData()
    },
    handleDelete (row) {
      const params = {
        coalMsgId: row.coalId,
        dispatchStatus: -1,
      }
      this.isLoading = true
      this.editDispatch(params).then(res => {
        this.isLoading = false
        if (res.paCode !== '000') {
          this.$message.error(res.paMsg || '操作失败');
        } else {
          this.$message.success(res.paMsg || '操作成功');
          this.refreshData()
        }
      })
    },
    handleShowDetail (row) {
      this.getDispatchDetail({
        coalId: row.coalId
      }).then(res => {
        if (res.paCode === '000') {
          this.detailParams = {
            title: '详情',
            showFooter: true
          }
          this.imageList = res.paData.urlList
          this.showDetailDrawer = true
        }
      })
    },
    closeDetailDrawer () {
      this.showDetailDrawer = false
    },
    handleEdit (row) {
      this.editParams = {
        title: '详情',
        showFooter: true
      }
      this.dispatchDetail = row
      this.showEditDrawer = true
    },
    closeEditDrawer () {
      this.showEditDrawer = false
    },
    handleSubmit () {
    
    }
  }
}
</script>

<style scoped lang="less">
.top-content {
  height: 30px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding-bottom: 12px;
}
.total-count-content {
  margin-right: 8px;
  font-size: 14px;
  color: #5b6b7e;
  border: 1px solid #5b6b7e;
  border-radius: 5px;
  padding: 1px 6px;
  font-weight: bold;
}
.title-content {
  margin-right: 16px;
}
.refresh-icon {
  font-size: 18px;
  color: #4a90e2;
}
/deep/ .vxe-table--render-default .vxe-header--column:not(.col--ellipsis) {
  padding: 8px 0;
}
.upload-QR-code-content {
  ::v-deep .el-upload {
    width: 150px;
    height: 150px;
    .el-upload-dragger {
      width: 100%;
      height: 100%;
      display: flex;
      align-items: center;
      justify-content: center;
    }
  }
}
.form-icon {
  font-size: 20px;
  margin-right: 4px;
  position: relative;
  top: 2px;
}
</style>